// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:960px){.sidebar-content[data-v-324d0c14]{height:100%;background-color:var(--q4s-white);z-index:10;left:0}}.sidebar.open .sidebar-overlay[data-v-324d0c14]{position:fixed;width:100%;height:100%;z-index:1;background-color:rgba(0,0,0,.5);left:0;top:0}.sidebar.open .sidebar-content[data-v-324d0c14]{transform:translateX(0)}", ""]);
// Exports
module.exports = exports;
